
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politicas-de-privacidad",
      function () {
        return require("private-next-pages/politicas-de-privacidad.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politicas-de-privacidad"])
      });
    }
  